import { message } from 'antd';
import intl from 'react-intl-universal';
import md5 from 'crypto-js/md5';
import { langs } from 'Utils/language';
import { store } from 'Store/store.index'
import { isMobile as IS_MOBILE } from 'Utils/device';
import { isIE } from 'Utils/browser-info';
import { transitionDirectionMap } from '../../src/components/dialogs/constants/index';
// import {
//     split,
//     wipe,
//     push,
//     blinds,
//     cover,
//     uncover,
//     fly,
//     box,
//     dissolve,
//     glitter,
//     fade,
// } from './transitions';
export const prop = (obj, attr) => obj[attr];
export const updateProp = (obj, key, attr) => obj[key] = attr;
// environmentName: us, ch, jp, eu, fzk8s, azk8s, demo4.

import { compareDialog } from '../locales/en-US/dialogs/compareDialog';

import { baseUrlApis } from '@/api';
import { URL_CWS_API, IS_NEED_AB_ROLE } from 'Api/constants';

// environmentName: us, ch, jp, fzk8s, azk8s, demo4.
export const ENV_TYPE = {
  PDFONLINE: 'us',
  CN: 'ch',
  JP: 'jp',
  EU: 'eu',
  CA: 'ca',
  FZK8S: 'fzk8s',
  AZK8S: 'azk8s',
  DEMO4: 'demo4',
  LOCAL: 'local'
}
// query 'env'
export const ENV_VALUES = [
  'cn', 'us', 'jp', 'eu', 'ca'
]
export const DOMAINS_TYPE = {
  // ONLINERD-11714, DingTalk domain test
  [ENV_TYPE.CN]: ['online.foxitsoftware.cn', 'onlinecn-devazk8s.connectedpdf.com', 'app105967.eapps.dingtalkcloud.com', 'online-stgcn.connectedpdf.com'],
  [ENV_TYPE.JP]: ['pdfonline.foxit.co.jp','pdfonline-stgjp.connectedpdf.com', 'pdfonline-jpazk8s.connectedpdf.com'],
  [ENV_TYPE.PDFONLINE]: ['pdfonline.foxit.com', 'pdfonline-eu1.foxit.com'],
  [ENV_TYPE.EU]: ['pdfonline-eu1.foxit.com'],
  [ENV_TYPE.CA]: ['pdfonline-na2.foxit.com'],
  [ENV_TYPE.AZK8S]: ['pdfonline-azk8s.foxitcloud.com', 'online-azk8s.foxitcloud.com', 'pdfonline-azk8s.connectedpdf.com', 'online-azk8s.connectedpdf.com', 'pdfonline-caazk8s.connectedpdf.com', 'pdfonline-euazk8s.connectedpdf.com', 'teams_app.online-azk8s.foxitcloud.com'],
  [ENV_TYPE.FZK8S]: ['online-fzk8s.connectedpdf.com', 'pdfonline-fzk8s.connectedpdf.com'],
  [ENV_TYPE.DEMO4]: ['online-demo4.connectedpdf.com', 'pdfonline-demo4.connectedpdf.com'],
  [ENV_TYPE.LOCAL]: ['localhost', '127.0.0.1']
}
export function isAzk8sByDomain() {
  const host = prop(location, 'host')

  return DOMAINS_TYPE[ENV_TYPE.AZK8S].indexOf(host) > -1
}
export function isPhantomOnline() {
  if (window.platform && window.platform === 'PhantomOnline') {
    return true
  }

  return false
}
export function checkNullObj(obj) {
  return Object.keys(obj).length === 0
}
export function loadScript(url, params = {}, /* callback */) {
  return new Promise((resolve, reject) => {
    let head = document.getElementsByTagName('head')[0];
    let script = document.createElement('script');
    script.type = 'text/javascript';
    if (Object.keys(params).length) {
      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          script[key] = params[key];
        }
      }
    }

    if (script.readyState) {
      script.onreadystatechange = function () {

        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // script.οnlοad=function(){
      //   resolve();
      // }
      script.onload = resolve;
      script.onerror = reject;
    }
    script.src = url;
    head.appendChild(script);
  });
}
export function loadImage(url, attrs /* callback */) {
  return new Promise((resolve/* , reject */) => {
    let head = document.getElementsByTagName('head')[0];
    let image = document.createElement('img');
    if (attrs) {
      attrs.id && image.setAttribute('id', id);
      //'display:none;'
      attrs.style && image.setAttribute('style', attrs.style);
    }

    const onLoaded = (e) => {
      resolve(e);
    }
    const onError = (e) => {
      console.error("loadImage onError -> e", e)
      //reject(e);
    }

    if (image.readyState) {
      image.onreadystatechange = function () {

        if (image.readyState == 'loaded' || image.readyState == 'complete') {
          image.onreadystatechange = null;
          onLoaded();
        }
      };
    } else {

      image.onload = onLoaded;
      image.onerror = onError;
    }
    image.src = url;
    head.appendChild(image);
  });
}

export function loadVconsole(fileUrl) {
  let isDebug = getQueryVariable('debug');
  !fileUrl && (fileUrl = '/vconsole.min.js')
  if (isDebug && isDebug !== 'none') {
    loadScript(fileUrl).then(() => {
      var vConsole = new VConsole();
      window.__vConsole__ = vConsole;
      if (!!vConsole) {
        let logFn = prop(console, 'log');
        const fn = (...args) => {
          try {
            logFn(...args);
          } catch (error) {
            console.error(error);
          }
        };
        updateProp(console, 'log', fn);
        prop(console, 'info')('============= load VConsole successfully... =============');
      }
    });
  }
}

/**
 * @export
 * @param {Array} domains
 * @returns {Boolean}
 */
export function isParentNode(p, c2) {
  var c = c2;
  while (c.parentNode) {
    c = c.parentNode;
    if (c == p)
      return true;
  }
  return false;
}
export function isInTargetDomains(domains) {
  if (!domains) return false;
  let baseUrl = getBaseUrl();
  let item = domains.find((target) => {
    if (baseUrl.indexOf(target) !== -1) {
      return true;
    }
    return false;
  })
  return !!item;
}
export function isInTargetEnv(env) {
  if (!env || !store) return false;
  if (!store.isLoading) {
    const { environmentName } = store.appStore;
    if (env === environmentName) {
      return true;
    }
    if (environmentName !== void 0) {
      return false;
    }
  }
  //return true;
  let envDomain = DOMAINS_TYPE[env];
  return isInTargetDomains(envDomain);
  //return false;
}
function isEnableQuery_env() {
  return isInTargetDomains([
    'azk8s.connectedpdf.com',
    'azk8s.foxitcloud.com',
    'pdfonline-azk8s.foxitcloud.com',
    'online-fzk8s.connectedpdf.com',
    'online-demo4.connectedpdf.com',
    'localhost', '127.0.0.1', '10.111.12.11']);
}

function queryEnvForNotProduction() {
  if (!isEnableQuery_env()) {
    return '';
  }
  let env = getQueryVariable('env');
  if(ENV_VALUES.includes(env)){
    return env;
  }
  return '';
}

window.isInTargetDomains = isInTargetDomains;
export function getCurrentCommitId() {
  const commitId = __hashVersion__

  return commitId
}
export function isCNDomain() {
  //return true;
  const env = queryEnvForNotProduction();
  if(!env){
    return isInTargetEnv(ENV_TYPE.CN);
  }
  if (env === 'cn') {
    return true;
  }
  return false;
}
export function isTestDomainForTeams() {
  const envDomain = ["teams_app.online-azk8s.foxitcloud.com", "pdfonline-stgus.connectedpdf.com"]

  return isInTargetDomains(envDomain);
}
export function isAzk8sDomain() {
  //return true;
  if (getQueryVariable('server_config') === 'azk8s') {
    return true;
  }
  const env = queryEnvForNotProduction();
  if(!env){
    const envDomain = DOMAINS_TYPE[ENV_TYPE.AZK8S];

    return isInTargetDomains(envDomain);
  }
  if (env === 'azk8s') {
    return true;
  }
  return false;
}
// us and eu
export function isPdfOnlineDomain() {
  //return true;
  if (getQueryVariable('server_config') === 'pdfonline') {
    return true;
  }
  const env = queryEnvForNotProduction();
  if(!env){
    return isInTargetEnv(ENV_TYPE.PDFONLINE);
  }
  if (env === 'us') {
    return true;
  }
  return false;
}
export function isJPDomain() {
  //return true;
  if (queryEnvForNotProduction() === 'jp') {
    return true;
  }
  const env = queryEnvForNotProduction();
  if(!env){
    return isInTargetEnv(ENV_TYPE.JP);
  }
  if (env === 'jp') {
    return true;
  }
  return false;
}
export function isEUDomain() {
  //return true;
  if (queryEnvForNotProduction() === 'eu') {
    return true;
  }
  const env = queryEnvForNotProduction();
  if(!env){
    return isInTargetEnv(ENV_TYPE.EU);
  }
  if (env === 'eu') {
    return true;
  }
  return false;
}
export function isCADomain() {
  //return true;
  if (queryEnvForNotProduction() === 'ca') {
    return true;
  }
  const env = queryEnvForNotProduction();
  if(!env){
    return isInTargetEnv(ENV_TYPE.CA);
  }
  if (env === 'ca') {
    return true;
  }
  return false;
}
export function isCommonFeatureDomain() {
  //return true;
  if (isEUDomain() || isCADomain()){
    return true
  } else {
    return false
  }
}
export function getJPOnlineUrl() {
  return "https://" + DOMAINS_TYPE[ENV_TYPE.JP][0];
}
export function getOnlineUrl(envType) {
  let domains = DOMAINS_TYPE[envType];
  if (typeof domains !== 'undefined') {
    domains = "https://" + domains[0];
  } else {
    domains = '';
  }
  return domains;
}
export function isFZK8SDomain() {
  //return true;
  if (queryEnvForNotProduction() === 'fzk8s') {
    return true;
  }
  return isInTargetEnv(ENV_TYPE.FZK8S);
}
export function isDemo4Domain() {
  //return true;
  let env = getQueryVariable('server_config');
  if (env === 'p-demo' || env === 'demo4') {
    return true;
  } else if (queryEnvForNotProduction() === 'demo4') {
    return true;
  }
  return isInTargetEnv(ENV_TYPE.DEMO4);
}
export function isDevDomain() {
  return isInTargetEnv(ENV_TYPE.LOCAL);
}

export function isMobile() {
  return IS_MOBILE;
}

export function getBrowserDefaultLanguage() {
  let language = navigator.language || navigator.userLanguage;
  // fix error when language is one of 'zh','en',...
  if (langs[language] !== void 0) {
    language = langs[language].full;
  }
  return language;
}
const langFullMap={
  'da':'da-DK',
  'en':'en-US',
  'fi':'fi-FI',
  'ja':'ja-JP',
  'nb':'nb-NO',
  'pl':'pl-PL',
  'ru':'ru-RU',
  'zh':'zh-CN',
  'de':'de-DE',
  'es':'es-419',
  'fr':'fr-FR',
  'it':'it-IT',
  'ko':'ko-KR',
  'nl':'nl-NL',
  'pt':'pt-BR',
  'sv':'sv-SE',
  'zhtw':'zh-TW',
}
export function getBrowserLanguage() {
  let language = navigator.language || navigator.userLanguage;
  if (isCNDomain()) {
    language = 'zh-CN'
  } else if (isJPDomain()) {
    language = 'ja-JP'
  } else {
    let storageLanguage = storageGetItem(localStorage, 'language') !== 'null' ? storageGetItem(localStorage, 'language') : '';
    const isUseBrowser = getLanguageIsFollowSystem();
    if (storageLanguage && !isUseBrowser) {
      language = storageLanguage;
    }
    const urlArr = window.location.href.split('&');
    const urlLang = urlArr.find((item) => item.startsWith('al='));
    if(urlLang){
      language = urlLang.split('=')[1]
    }
  }
  // fix error when language is one of 'zh','en',...
  if (langs[language] !== void 0) {
    language = langs[language].full;
  }

  let langInUrl = getQueryVariable('lang');
  if (langInUrl) language = langInUrl;

  let alInUrl = null;
  let pathname = prop(location, 'pathname');
  if (pathname && (pathname.indexOf('collaboration.html') !== - 1)) {
    alInUrl = getQueryVariable('al');
    if (alInUrl) language = alInUrl;
  }

  let lang = language.substr(0, 2);
  if (language.toLowerCase() === 'zh-tw') {
    lang = 'zhtw';
  }
  if (alInUrl || (langs[lang] !== void 0)) {
    return { lang: lang, full: langFullMap[lang] }; // zh-CN ja-JP ko-KR;
  } else {
    return { lang: 'en', full: 'en-US' }; // en-US;
  }
}

export function getLanguageIsFollowSystem() {
  let isFollowSystem = JSON.parse(storageGetItem(localStorage, 'isSystemlanguage'));
  if (isFollowSystem !== null) {
    return !!isFollowSystem;
  }
  return true;
}

export function needABTest() {
  return IS_NEED_AB_ROLE === 1;
}

//example: window.open => windowAction(window, 'open', args);
export function windowActionFn(_window, fnName, args) {
  if (!_window && typeof _window[fnName] !== 'function') return;
  return _window[fnName](...args);
}
export function storageGetItem(storage, key) {
  if (!storage) return null;
  return storage.getItem(key);
}
//window.localStorage.removeItem
export function storageRemoveItem(storage, key) {
  if (!storage) return null;
  return storage.removeItem(key);
}
export function storageClear(storage) {
  storage && storage.clear();
}

export function storageSetItem(storage, key, value) {
  storage && key && storage.setItem(key, value);
}

export function isMore20201231() {
  /*// local time '2021/01/01 00:00:00'
  let date = new Date(2021, 0, 1, 0, 0, 0).getTime();
  // now
  let nowDate = new Date().getTime();
  let dateUrlParam = getQueryVariable('now_date')
  if(dateUrlParam){
    nowDate = new Date(1609430400000 +1000*3600*24);
  }
  if(nowDate>date){
    return true;
  }*/
  //if (isCNDomain()) return true;
  return true;
}

export function blobToBase64(blob) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onloadend = (/* e */) => {
      let data = reader.result;
      resolve({ ret: 0, data: data });
    }
    reader.onerror = (error) => {
      resolve({ ret: 999, data: error })
    }
  })
}

export function isPngImage(base64String) {
  return new Promise((resolve, reject) => {
    if (!base64String.startsWith('data:image/png')) {
      resolve(false);
    }
    const image = new Image();
    image.onload = function() {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const pixelCount = Math.min(100, imageData.data.length / 4);
      for (let i = 0; i < pixelCount; i++) {
        if (imageData.data[i * 4 + 3] !== 0) {
          resolve(false);
        }
      }
      resolve(true);
    };
    image.onerror = reject;
    image.src = base64String;
  });
}

export function replaceColorsInPng(base64String) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const image = new Image();
    image.onload = function() {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < imageData.data.length; i += 4) {
        const r = imageData.data[i];
        const g = imageData.data[i + 1];
        const b = imageData.data[i + 2];
        const a = imageData.data[i + 3];
        if (r === 255 && g === 255 && b === 255) {
          imageData.data[i + 3] = 0;
        } else {
          imageData.data[i] = 0;
          imageData.data[i + 1] = 0;
          imageData.data[i + 2] = 0;
          imageData.data[i + 3] = a;
        }
      }
      context.putImageData(imageData, 0, 0);
      canvas.toBlob(
        blob => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => resolve(reader.result);
        },
        'image/png',
        1
      );
    };
    image.onerror = reject;
    image.src = base64String;
  });
}

export function transparentImgBg(base64Str) {
  let img = new Image();
  img.src = base64Str;
  let canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  let ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let pixels = imageData.data;

  // 遍历像素,移除白色背景
  // 白色背景判断阈值,255为完全白色,暂时设置一个范围 245-255 ，在该区间内的都属于白色
  const threshold = 245;
  for (let i = 0; i < pixels.length; i += 4) {
    if (pixels[i] > threshold && pixels[i + 1] > threshold && pixels[i + 2] > threshold) {
      // 设置透明度为0，即完全透明
      pixels[i + 3] = 0;
    }
  }

  // 返回新的base64
  ctx.putImageData(imageData, 0, 0);
  return canvas.toDataURL();
}

export function blobToArrayBuffer(blob) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsArrayBuffer(blob);

    reader.onloadend = (/* e */) => {
      let data = reader.result;
      resolve({ ret: 0, data: data });
    }
    reader.onerror = (error) => {
      resolve({ ret: 999, data: error })
    }
  })
}

export function base64ToBlob(base64) {
  let arr = base64.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bStr = atob(arr[1]), n = bStr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bStr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export function blobToString(blob) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsText(blob);

    reader.onloadend = (/* e */) => {
      let data = reader.result;
      resolve({ ret: 0, data: data });
    }
    reader.onerror = (error) => {
      resolve({ ret: 999, data: error })
    }
  })
}

export const removeWhiteBgFromBase64 = base64 => {
  return new Promise((resolve)=>{
      let imgData = null;
      const [r0, g0, b0, a0] = [255, 255, 255, 255];
      let r, g, b, a;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const imgDomObj = new Image();
      imgDomObj.onload = ()=>{
          const w = imgDomObj.width;
          const h = imgDomObj.height;
          canvas.width = w;
          canvas.height = h;
          context.drawImage(imgDomObj, 0, 0);
          imgData = context.getImageData(0, 0, w, h);
          for (let i = 0; i < imgData.data.length; i += 4) {
              r = imgData.data[i];
              g = imgData.data[i + 1];
              b = imgData.data[i + 2];
              a = imgData.data[i + 3];
              const t = Math.sqrt((r - r0) ** 2 + (g - g0) ** 2 + (b - b0) ** 2 + (a - a0) ** 2);
              if (t <= 60) {
                  imgData.data[i] = 0;
                  imgData.data[i + 1] = 0;
                  imgData.data[i + 2] = 0;
                  imgData.data[i + 3] = 0;
              }
          }
          context.putImageData(imgData, 0, 0);
          resolve(canvas.toDataURL('image/png'));
      }
      imgDomObj.src = base64;
  })
}

export const base64toArrayBuffer = base64 => {
  let rawData;
  if (base64.indexOf(',') > -1) {
    rawData = atob(base64.split(',')[1])
  } else {

    rawData = atob(base64);
  }
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray.buffer;
}

export function isValidUrl(url) {
  return /https?:\/\/([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?/.test(url);
}
export function getAppTitle() {
  return intl.get("PhantomPDF.Online.AppTitle");
}

export function getProductNameForDashboard() {
  if (isJPDomain()) {
    return 'Phantom Online for JP';
  }

  return 'Phantom Online';
}

export function UTCTimeFormat(time) {
  if (time.indexOf('T') !== -1) return time;
  //
  const words = time.split(':')
  let hasSecond = words.length === 3;
  //let hasMiniSecond = time.indexOf('.') !== -1;

  //if(time.)
  //"2019-08-10T02:37:54.770Z"
  let _time = time.replace(' ', 'T');
  !hasSecond && (_time += ':00')
  _time += 'Z'
  return _time;
}

export function convertUTCToLocale(utcTimeString, isHideSeconds = false, seperator = "/") {
  let dateToHandle = new Date(utcTimeString);
  let year = dateToHandle.getFullYear();
  let month = dateToHandle.getMonth() + 1 < 10 ? `0${dateToHandle.getMonth() + 1}` : dateToHandle.getMonth() + 1;
  let date = dateToHandle.getDate() < 10 ? `0${dateToHandle.getDate()}` : dateToHandle.getDate();
  let hours = dateToHandle.getHours() < 10 ? `0${dateToHandle.getHours()}` : dateToHandle.getHours();
  let minutes = dateToHandle.getMinutes() < 10 ? `0${dateToHandle.getMinutes()}` : dateToHandle.getMinutes();
  let seconds = dateToHandle.getSeconds() < 10 ? `0${dateToHandle.getSeconds()}` : dateToHandle.getSeconds();
  if (isHideSeconds) {
    return `${year}${seperator}${month}${seperator}${date} ${hours}:${minutes}`;
  }

  return `${year}${seperator}${month}${seperator}${date} ${hours}:${minutes}:${seconds}`;
}
export function utcTimeString(utcTime) {
  let date = new Date(utcTime);
  let year = date.getUTCFullYear();
  let month = date.getUTCMonth();
  let day = date.getUTCDate();
  month = month + 1 < 10 ? `0${month + 1}` : month + 1;
  day = day + 1 < 10 ? `0${day + 1}` : day;
  return `${month}/${day}/${year}`;
}

export function UTCTimeToLocale(time) {
  let t = UTCTimeFormat(time);
  return convertUTCToLocale(t);
}

/**
 * @export
 * @param {Number} size B
 * @param {Number} type 1: to MB, 2: to KB
 * @return {String}
 */
export function getFileSize(size, type) {
  const B_TO_KB = 1024;
  const B_TO_MB = 1048576;

  if (size >= 1048576 || type === 1) {
    return `${(size / B_TO_MB).toFixed(2)}MB`;
  } else {
    return `${(size / B_TO_KB).toFixed(2)}KB`;
  }
}
export function convertFileSizeToKBSize(size) {
  const sizeLower = size.toLowerCase()
  const sizeFloat = parseFloat(size)

  if (sizeLower.indexOf('kb') > -1) {
    return sizeFloat
  }

  if (sizeLower.indexOf('mb') > -1) {
    return sizeFloat * 1024
  }

  if (sizeLower.indexOf('gb') > -1) {
    return sizeFloat * 1024 * 1024
  }
}

export function getFileNameWithoutExtension(text) {
  let pattern = /\.{1}[a-z]{1,}$/;

  if (pattern.exec(text) !== null) {
    return text.slice(0, pattern.exec(text).index);
  } else {
    return text;
  }
}

export function getFileNameByUrl(url) {
  let filename = url.substring(url.lastIndexOf('/') + 1);
  return filename;
}

export function handlerFileNameWithoutExtension(fileName) {
  const startIndex = fileName.lastIndexOf('.')

  if (startIndex > 0) {
    const extension = fileName.substring(startIndex)

    if (extension === '.pdf') {
      return fileName
    }
  }

  return `${fileName}.pdf`;
}

//   /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/
//   /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/
let passwordReg = /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/
export function isValidPassword(password) {
  if (!password) return false;
  let flag = passwordReg.test(password);
  return flag;
}
export function isValidURL(input) {
  return !!input.match(/(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)(:\d{0,5})?((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g);
}

export function isValidIP(ip) {
  var reg = /(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])/
  return reg.test(ip);
}
export function isBlank(text) {
  return (!text || /^\s*$/.test(text));
}
export function removeCJK(text) {
  if (!text) {
    return ''
  }
  let reg = /[\u2E80-\u9FFF]/g;
  return text.replace(reg, "");
}

export function getQueryVariable(variable) {
  let newProp = prop;
  if(!newProp){
    newProp = (obj, attr) => obj[attr];
  }
  let query = newProp(location, 'search').substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] === variable) {
      let value = decodeURIComponent(pair[1]);
      return value;
    }
  }
  return null;
};
export function queryVariable (variable) {
  if (!variable) return null;
  let search = location.href;
  search = search.substring(search.indexOf('?'));
  return new URLSearchParams(search).get(variable);
}

export function getTargetQuery(url, target) {
  let urlsearch = url.split('?');
  let queryArr = urlsearch[1].split('&');
  for (let i = queryArr.length - 1; i >= 0; i--) {
    let tep = queryArr[i].split("=");
    if (tep[0] == target) {
      return decodeURIComponent(tep[1]);
    }
  }
  return (false);
}

export function changeUrlArg(url, arg, val) {
  var pattern = arg + '=([^&]*)';
  var replaceText = arg + '=' + val;
  if (!url.match(pattern)) {
    return url;
  }
  return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) : (url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText);
}
export function getBaseUrl() {
  let newProp = prop;
  if(!newProp){
    newProp = (obj, attr) => obj[attr];
  }
  const href = newProp(location, 'href')
  let path = newProp(location, 'pathname');
  let startPos = newProp(location, 'protocol').length + 2;
  let pos = href.indexOf(path, startPos);
  let host = href.substring(0, pos);
  let baseUrl = host + '/';

  return baseUrl;
};

export function copyText(text, callback, error) {
  const area = document.createElement('textarea');
  area.value = text;
  document.body.appendChild(area);
  area.select();
  area.setSelectionRange(0, area.value.length);
  document.execCommand('copy');
  try {
    let successful = document.execCommand('copy');
    successful ? (callback && callback()) : (error && error());
  } catch (err) {
    console.error(err);
    error && error()
    //alert('该浏览器不支持点击复制到剪贴板');

  }
  document.body.removeChild(area);
}

export function getFoxitStoreDomain() {
  let domain = '';
  if (isDevDomain() || isAzk8sDomain() || isDemo4Domain()) {
    domain = 'https://www-test.foxitsoftware.com';
  } else {
    domain = 'https://www.foxit.com';
  }
  // domain may not correct
  const href = window.location.href;
  if (href.includes('localhost') || href.includes('azk8s') || href.includes('demo4')) {
    domain = 'https://www-test.foxitsoftware.com';
  }
  return domain;
}
// window.performance.memory
export function createPerformanceNode(id, fileName, time) {

  if(!time){
    time = Date.now();
  }
  const run = ()=>{
    try {
      let $$ = window.UIExtension.jQuery;
      const createParent = () => {
        let parent = $$('#sdk-result');
        if (parent.length !== 0) {
          return parent;
        }
        const node = document.createElement('div');
        node.id = 'sdk-result';
        $$(node).css({ 'position': 'fixed', 'bottom': '0', 'z-index': '100000', 'background':'white', 'height': '200px', 'overflow': 'auto' })
        $$('body').append(node);

        return $$('#sdk-result');
      }

      let parent = createParent();

      let text = {
        id,
        time: time,
        memory: {  },
      }
      if (window.performance.memory) {
        const { totalJSHeapSize, usedJSHeapSize, jsHeapSizeLimit } = window.performance.memory;
        text['memory'] ={ totalJSHeapSize, usedJSHeapSize, jsHeapSizeLimit };
        //return;
      }
      const node = document.createElement('span');
      fileName && (text['fileName'] = fileName);
      node.innerText = JSON.stringify(text);
      node.id = id;
      //node.style.display = 'none';
      parent.append(node);
      parent.append('<br>');

    } catch (/* error */e) {
      console.error(e);
    }

  }
  if(window.UIExtension){
    run();
    return;
  }

  let handle = setInterval(()=>{
    if(!window.UIExtension){
      return;
    }
    clearInterval(handle);
    run();
  }, 2000);

}
Date.prototype.format = function (fmt) {
  let o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds(),
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
}

export function convertMIMETypeToFileExtension(mimeType) {
  let result = ''

  switch (mimeType) {
    case 'msword':
      result = 'doc';
      break;
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
      result = 'docx';
      break;
    case 'vnd.ms-powerpoint':
      result = 'ppt';
      break;
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
      result = 'pptx';
      break;
    case 'vnd.ms-excel':
      result = 'xls';
      break;
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      result = 'xlsx';
      break;
    case 'plain':
      result = 'txt';
      break;
    case 'gif':
      result = 'gif';
      break;
    case 'bmp':
      result = 'bmp';
      break;
    case 'jpg':
      result = 'jpg';
      break;
    case 'jpeg':
      result = 'jpeg';
      break;
    case 'png':
      result = 'png';
      break;
    case 'tiff':
      result = 'tiff';
      break;
    case 'jpx':
      result = 'jpx';
      break;
    case 'tif':
      result = 'tif';
      break;
    case 'pdf':
      result = 'pdf';
      break
    default:
      break;
  }

  return result
}
// byte单位转换
export function bytesTobytes (bytes) {
  if (!bytes) return bytes;
  var data = '';
  if (bytes < 0.1 * 1024) {
      data = bytes.toFixed(2) + 'B';
  } else if (bytes < 0.1 * 1024 * 1024) {
      data = (bytes / 1024).toFixed(2) + 'KB';
  } else if (bytes < 0.1 * 1024 * 1024 * 1024) {
      data = (bytes / (1024 * 1024)).toFixed(2) + 'MB';
  } else {
      data = (bytes / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
  }
  var ret = data + '';
  var len = ret.indexOf('.');
  var dec = ret.substr(len + 1, 2);
  if (dec == '00') {
      return ret.substring(0, len) + ret.substr(len + 3, 2);
  }
  return ret;
}
export function apToHex(ap) {//透明度转16进制
  let i = ap * 100;
  let n = 255 * i / 100;
  let hexInteger = Math.round(n);
  let hex = hexInteger.toString(16);
  if (hex.length < 2) {
    hex = "0" + hex;
  }
  return hex;
}
export function colorToAARRGGBB(colorHex, ap) { //将16进制颜色 & 透明度  合并转换成AARRGGBB 格式

  let apHex = apToHex(ap);
  let color = `0x${apHex}${colorHex.substr(1)}`
  return Number(color);
}

export function tenToSixteen(ten) { //10进制转16进制
  let hex = Number(ten).toString(16);
  if(hex.length===1){
    hex = hex+hex+hex+hex+hex+hex;
  }
  return hex;
}
export function sixteenToTen(sixteen) { //16进制转10进制
  return parseInt(sixteen, 16);
}
export function RgbAndBgr(bgr) { //aabbcc -->ccbbaa
  const str = ''+bgr;
  const arr = str.split('');
  const res = ''+arr[4]+arr[5]+arr[2]+arr[3]+arr[0]+arr[1];
  return res;
}

export function trimEnd(str, c) {// 末尾删除某一个指定值 或者 空格
  if (c == null || c == "") {
    let rg = /s/;
    let i = str.length;
    while (rg.test(str.charAt(--i)));
    return str.slice(0, i + 1);
  }
  else {
    let rg = new RegExp(c);
    let i = str.length;
    while (rg.test(str.charAt(--i)));
    return str.slice(0, i + 1);
  }
}
// DOMTokenList
export function getDOMTokenListValue(classList) {
  if (!classList || classList.length === 0) {
    return '';
  }
  let value = !!classList.value ? classList.value : '';
  if (!value) {
    for (let index = 0; index < classList.length; index++) {
      const element = classList[index];
      value += element + ' ';
    }
    value = value.replace(/\s+$/g, '')
  }

  return value;
}

export function parseDateTimeString(time) {
  if (!time) {
    return null;
  }

  const reg = /^D\:(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(([+-]\d\d)('\d\d')?)?$/;
  const result = time.match(reg);

  if (!result) {
    return null;
  }

  const [, year, month, day, hour, minute, second, hourTimeZoneOffsetStr, minuteTimeZoneOffsetStr] = result;
  let minuteTimeZoneOffset = 0;

  if (minuteTimeZoneOffsetStr && minuteTimeZoneOffsetStr.length > 2) {
    minuteTimeZoneOffset = Number(minuteTimeZoneOffsetStr.replace(/['"]/g, ''));
    if (isNaN(minuteTimeZoneOffset)) {
      minuteTimeZoneOffset = 0;
    }
  }

  let hourTimeZoneOffset = Number(hourTimeZoneOffsetStr);

  if (isNaN(hourTimeZoneOffset)) {
    hourTimeZoneOffset = new Date().getTimezoneOffset() / -60;
  }

  let t = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    0,
  );

  t + 8 * 3600 * 1000

  return new Date(t)
}

export function copyToClipboard(text, success, fail) {
  const textarea = document.createElement('textarea');
  textarea.textContent = text;
  document.body.appendChild(textarea);
  var selection = document.getSelection();
  var range = document.createRange();
  range.selectNodeContents(textarea);
  selection.removeAllRanges();
  selection.addRange(range);
  textarea.select();
  // selection.getRangeAt(0).cloneContents();
  if (document.execCommand('copy')) {
    success && success();
  } else {
    fail && fail();
  }
  document.body.removeChild(textarea)
}
export function hasClass(element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

export function deepCopy(obj) {
  if (!obj) return
  let target = obj instanceof Array ? [] : {};
  if (typeof obj !== 'object') {
    return;
  }
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === 'object' && obj[key]) {
        target[key] = deepCopy(obj[key]);
      } else {
        target[key] = obj[key]
      }
    }
  }
  return target
}

export const createDeferred = () => {
  const deferred = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};

export function getPrivacyPolicyUrl() {
  // let privacyPolicyUrl = 'https://www.foxit.com/product/privacy-policy.html'; //getBaseUrl() + 'privacy-policy';
  
  // if (isCNDomain()) {
  //   privacyPolicyUrl = 'https://www.foxitsoftware.cn/company/privacy.html';
  // } else if (isPdfOnlineDomain()) {
  //   privacyPolicyUrl = 'https://www.foxit.com/product/privacy-policy.html';
  // } else if (isJPDomain()) {
  //   privacyPolicyUrl = 'https://www.foxit.co.jp/products/privacy-policy/';
  // }
  // TODO FOXIT 全局修改【隐私协议】为福网版本
  let privacyPolicyUrl = 'https://myd.pdf365.cn/agreement/foxitprivacy.html'; 
  return privacyPolicyUrl;
}

export function getTermsOfServiceUrl() {
  let termsOfServiceUrl = 'https://www.foxit.com/product/foxit-product-terms-of-service.html'; //getBaseUrl() + 'terms-of-service';
  if (isCNDomain()) {
    termsOfServiceUrl = 'https://www.foxitsoftware.cn/portal/products/onlineserviceseula.html';
  } else if (isPdfOnlineDomain() || isCommonFeatureDomain()) {
    termsOfServiceUrl = 'https://www.foxit.com/product/foxit-product-terms-of-service.html';
  } else if (isJPDomain()) {
    termsOfServiceUrl = 'https://www.foxit.co.jp/products/terms-of-service/';
  }
  return termsOfServiceUrl;
}

//let encryptPassword = encryptAES('123456+a', 'abcdefg123456789', '');
export function encryptAES(data, key, iv, ivMd5) {
  try {
    return import('crypto-js')
    .then(CryptoJS=>{
      CryptoJS=CryptoJS.default;
      // let keyMD5 = CryptoJS.MD5(key)
        if(!iv && ivMd5 === true) {
            let keyMd5 = CryptoJS.MD5(key).toString();
            iv = keyMd5.slice(0, 16);
        }
      let parseKey = CryptoJS.enc.Utf8.parse(key)
      let parseIv = CryptoJS.enc.Utf8.parse(iv)
      let encrypted = CryptoJS.AES.encrypt(data, parseKey, {
        iv: parseIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.toString()
    });

  } catch (err) {
    console.error(err);
    return Promise.resolve('');
  }
}

//let decryptPasswrod = decryptAES(encryptPassword, 'abcdefg123456789', '');
export function decryptAES(encryptedStr, key, iv) {
  try {
    return import('crypto-js')
      .then(CryptoJS=>{
      let parseKey = CryptoJS.enc.Utf8.parse(key)
      let parseIv = CryptoJS.enc.Utf8.parse(iv)
      let decryptedUtf8 = CryptoJS.AES.decrypt(encryptedStr, parseKey, {
        iv: parseIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      let decryptedData = decryptedUtf8.toString(CryptoJS.enc.Utf8)
      return decryptedData
    })
  } catch (err) {
    console.error(err);
    return Promise.resolve('');
  }
}

export function getBgIndex(userId) {
  const userBgColorList = ['#ba91ff', '#68AFFF', '#EF80DB', '#FFA800', '#75D060', '#48D3D5', '#E99570', '#758395', '#9DB4E2'];
  const length = userBgColorList.length
  if (!userId) return length - 1
  const key = userId[userId.length - 1]
  var s = 'a b c d e f g h i j k l m n o p q r s t u v w x y z 0 1 2 3 4 5 6 7 8 9';
  var sArray = s.split(' ');
  let keyIndex = 0
  sArray.forEach((item, index) => {
    if (key === item) keyIndex = index % length
  })
  return keyIndex
}
export function getUserBgColor(userId) {
  const userBgColorList = ['#ba91ff', '#68AFFF', '#EF80DB', '#FFA800', '#75D060', '#48D3D5', '#E99570', '#758395', '#9DB4E2'];
  return userBgColorList[getBgIndex(userId)]
}
export function doExport(actions, method = "get", params) {
  let formSubmit = true;
  const onbeforeunload = window.onbeforeunload;
  if(onbeforeunload) {
    window.onbeforeunload = (event)=>{
      if(!formSubmit)
        onbeforeunload(event);
      formSubmit = false;
    }
  }
  let form = document.createElement('form');
  form.action = actions;
  form.method = method;
  for (let key in params) {
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = params[key];
    form.append(input)
  }
  document.body.append(form);
  form.submit();
  form.remove();
}
export function outputVersion() {
  //window.__onlineBranch__ = "develop: 433198597bf9dc8a120399d5e29af79e21165523";
  if (!window.__onlineBranch__) {
    return;
  }
  let list = window.__onlineBranch__.split(': ');
  if (list.length < 2) {
    return;
  }
  let details = {
    "online branch": { value: list[0] },
    "version": { value: list[1] },
  };

  // TODO FOXIT 监控平台——err：TypeError: Uncaught TypeError: Illegal invocation
  prop(console, 'table') && prop(console, 'table')(details);
  !console.table && console['log']("online branch: ", details);
}

export function getClipboardData(isShowMessage = true) {
  if (!navigator.clipboard || typeof navigator.clipboard.read !== 'function' || isIE) {
    if (isShowMessage) {
      store.appStore.onShowWarningMessage(null, {
        message: 'Convert.BrowserNotSupport',
        title: 'PhantomPDF.Online.TitleWithOnline',
      }, true);
      return Promise.resolve();
    }
    return Promise.resolve({
      type: 'error',
      infoKey: 'BrowserNotSupport'
    })
  }
  if (!window.isSecureContext) {
    if (isShowMessage) {
      store.appStore.onShowWarningMessage(null, {
        message: 'Convert.SecureContext',
        title: 'PhantomPDF.Online.TitleWithOnline',
      }, true);
      return Promise.resolve();
    }
    return Promise.resolve({
      type: 'error',
      infoKey: 'SecureContext'
    })
  }

  const deferred = createDeferred();
  navigator.clipboard.read().then(clipboardData => {
    const item = (clipboardData || [])[0];
    if (!item) return;

    const imageIndex = item.types.findIndex(item => item.indexOf('image/') === 0);
    if (item.types.includes('text/html')) {
      item.getType('text/html').then(blob => {
        deferred.resolve({ type: 'text/html', blob });
      });
    } else if (imageIndex >= 0) {
      item.getType(item.types[imageIndex]).then(blob => {
        deferred.resolve({ type: item.types[imageIndex], blob });
      });
    } else if (item.types.includes('text/plain')) {
      item.getType('text/plain').then(blob => {
        deferred.resolve({ type: 'text/plain', blob });
      });
    }
  }).catch(e => {
    process.env.NODE_ENV === 'development' && console.error(e);
    if (isShowMessage) {
      message.info(intl.get('Convert.NoDataAtClipboard'));
      deferred.resolve();
      return;
    }
    Promise.resolve({
      type: 'error',
      infoKey: 'NoDataAtClipboard'
    })
  });

  return deferred.promise;
}

export function sleep(second) {
  return new Promise((resolve) => {
    let handle = setTimeout(() => {
      clearTimeout(handle);
      resolve();
    }, second * 1000);
  })
}

export function getContainerHeight() {
  const $dom = document.querySelector('.header_container')
  if (null === $dom) return 0;
  return $dom.clientHeight;
}
export function getDocumentViewMode() {
  const documentSettings = window.localStorage.getItem('PREFERENCES-DOCUMENTS');
  if (!documentSettings) return 'onlyForPDFA';
  const { vieMode } = JSON.parse(documentSettings);
  return vieMode;
}

export function getCookie(key) {
  let cookies = document.cookie
  let cookieArr = cookies.split(";")
  let cookieObj = {}
  cookieArr.forEach(item => {
    let arr = item.split("=")
    cookieObj[arr[0].trim()] = arr[1]
  })
  // alert(JSON.stringify(cookieObj))
  console.log(cookieObj)
  return cookieObj[key]
}
export function getElementByIconClass(iconClassName) {
  return document.querySelector(`div[icon-class=${iconClassName}]`);
}
export async function doTransition(transition, customPageRender) {
  const { transitionName, speed, direction } = transition;
  const dom = document.getElementsByClassName('custom-page');
  const target = document.getElementsByClassName('fv__pdf-doc-container');
  Velocity(dom, 'stop');
  Velocity(target, 'stop');
  switch(transitionName) {
    case 'Split':
      split(customPageRender.customPrePageRender, direction, speed);
      break;
    case 'Blinds':
      blinds(customPageRender.customPrePageRender, direction, speed);
      break;
    case 'Wipe':
      wipe(customPageRender.customPrePageRender, direction, speed);
      break;
    case 'Push':
      push(customPageRender, direction, speed);
      break;
    case 'Box':
      box(customPageRender.customPrePageRender, direction, speed);
      break;
    case 'Cover':
      cover(customPageRender, direction, speed);
      break;
    case 'Uncover':
      uncover(customPageRender.customPrePageRender, direction, speed);
      break;
    case 'Fly':
      fly(customPageRender, direction, speed);
      break;
    case 'Dissolve':
      dissolve(customPageRender.customPrePageRender, speed);
      break;
    case 'Glitter':
      glitter(customPageRender.customPrePageRender, direction, speed);
      break;
    case 'Fade':
      fade(customPageRender.customPrePageRender, speed);
      break;
    default:
      break;
  }
}
function getDirection(transitionName, localDirection, isLeft) {
  const transition = transitionDirectionMap[transitionName];
  if(!transition) return 0;
  const transitionLength = transition.length;
  if(transitionLength === 0 || transitionName === 'Blinds') {
    return 0;
  }
  let result = [];
  const transitionValues = transition.map(item => item.value);
  if(transitionLength === 2) {
    result = transitionValues;
  }
  if(transitionLength === 4) {
    if(transitionName === 'Push' || transitionName === 'Fly') {
      if(localDirection < 2) {
        result[0] = transitionValues[localDirection];
        result[1] = transitionValues[localDirection + 2];
      } else {
        result[0] = transitionValues[localDirection];
        result[1] = transitionValues[localDirection - 2];
      }
    } else {
      if(localDirection % 2 === 0) {
        result[0] = transitionValues[localDirection];
        result[1] = transitionValues[localDirection + 1];
      } else {
        result[0] = transitionValues[localDirection];
        result[1] = transitionValues[localDirection - 1];
      }
    }
  }
  if(transitionLength === 8) {
    if(localDirection < 4) {
      result[0] = transitionValues[localDirection];
      result[1] = transitionValues[localDirection + 4];
    } else {
      result[0] = transitionValues[localDirection];
      result[1] = transitionValues[localDirection - 4];
    }
  }
  return isLeft ? result[0] : result[1];
}
export function getLocalTransition(previusPageIndex, pageIndex) {
  const localKey = 'formPreference';
  const localString = window.localStorage.getItem(localKey);
  const defaultResult = { transitionName: '', direction: 0, ignoreTransition: false };
  if(!localString) return defaultResult;
  const localSettings = JSON.parse(localString);
  const fullScreen = localSettings.fullScreen;
  if(!fullScreen) return defaultResult;
  const ignoreTransition = fullScreen.ignoreTransition;
  const isNavigationControl = fullScreen.isNavigationControl;
  const localDirection = Number(fullScreen.direction);
  const transitionName = fullScreen.transitionName;
  let direction = fullScreen.direction;
  if(isNavigationControl) {
    const isLeft = pageIndex - previusPageIndex >= 0;
    direction = getDirection(transitionName, localDirection, isLeft);
  }
  return { speed: 0, ignoreTransition, isNavigationControl, transitionName, direction: Number(direction || 0) }
}
let previusPageIndex = -1;
let timeStamp = 0;
export class cutomPageRender {
  constructor(eCustom, pdfPageRender) {
    this.eCustom = eCustom;
    this.pdfPageRender = pdfPageRender;
    this.isFullscreen = false;
    pdfPageRender.pdfViewer.viewerUI.rootComponent.pdfUI.eventEmitter.on('fullscreenchange', isFullscreen => {
      this.isFullscreen = isFullscreen;
      previusPageIndex = -1;
      this.rendered = false;
      const fvPdfPageLayout = document.querySelector('.fv__pdf-page-layout');
      if(isFullscreen) {
        fvPdfPageLayout.style.overflow = 'visible';
      } else {
        fvPdfPageLayout.style.overflow = 'hidden';
      }
    });
    this.rendered = false;
  }
  render() {
    // render函数被反复调用，导致不符合预期
    const now = (new Date()).getTime();
    if(now - timeStamp < 200 && this.rendered) {
      return;
    }
    timeStamp = (new Date()).getTime();
    this.rendered = true;
    this.renderHandles();
  }
  renderHandles() {
    const self = this;
    const pdfViewer = this.pdfPageRender.pdfViewer
    const isFullscreen = this.isFullscreen;
    return self.pdfPageRender.getPDFPage().then(async function (page) {
      const pageIndex =  page.info.index;
      // console.log(previusPageIndex, pageIndex);
      if(previusPageIndex === pageIndex && previusPageIndex !== -1) {
        return;
      }
      if (isFullscreen) {
        const { direction, ignoreTransition, transitionName } = getLocalTransition(previusPageIndex, pageIndex);
        if(ignoreTransition) return;
        let customPageRenderIndex = previusPageIndex < pageIndex ? previusPageIndex : pageIndex + 1;
        previusPageIndex = pageIndex;
        const pageTransition = await page.getTransition();
        const transition = { ...pageTransition };
        if(!pageTransition.transitionName) {
          transition.transitionName = transitionName;
          transition.direction = direction;
          transition.speed = 1;
        }
        const customPrePageRender = pdfViewer.getPDFPageRender(customPageRenderIndex);
        const customCurPageRender = pdfViewer.getPDFPageRender(pageIndex);
        if(!self.eCustom.innerHTML) self.eCustom.innerHTML = '<div class="fv__hand-state-contextmenu-container custom-page"></div>';
        await import('./DoTransition')
        .then(module=>{
          module.doTransition(transition, {
            customPrePageRender,
            customCurPageRender
          });
        })
      } else {
        self.eCustom.innerHTML = '';
      }
    })
  }
  destroy() {
    this.eCustom.innerHTML = '';
  }
}

export function getCompareResultStrings() {
  const compareResultStrings = {};
  Object.keys(compareDialog.compareResultStrings).forEach(key => {
    compareResultStrings[key] = intl.formatMessage({ id: `compareDialog.compareResultStrings.${key}`});
  })
  return compareResultStrings;
}

export const  localeStoreKey = "EDITOR_COMPAREDEFAULTOPTIONS";

export const defaultOptions = {
  include: [],
  color: {
    replace: '#ffcc00',
    insert: '#149bff',
    delete: '#fa0505',
  },
  opacity: {
    replace: 100,
    insert: 100,
    delete: 100,
  },
  line: {
    replace: 2,
    insert: 2,
    delete: 2,
  },
}


export function getDefaultCompareOptions() {
  let defaultLocalOptions;
  const dataStr = window.localStorage.getItem(localeStoreKey);
  try {
    defaultLocalOptions = JSON.parse(dataStr);
  } catch (error) {
    defaultLocalOptions = undefined;
  }
  return defaultLocalOptions || defaultOptions;
}
export function getFromDriveNameForSharePoint(webUrl) {
  let hintStr = 'sharepoint.com/sites'

  if (webUrl.indexOf(hintStr) > -1) {
    return 'SharePoint'
  } else {
    return 'OneDrive'
  }
}

let uniqueIdIndex = 0;
export const getUniqueId = (prefix) => {
  return [prefix || 'unique', new Date().getTime(), parseInt(Math.random() * 100), uniqueIdIndex++].join('_');
}
/**
 * @param start
 * @param end
 * @returns {number[start.......end]}
 */
export const generateArray = (start, end) => {
  return Array.from(new Array(end + 1).keys()).slice(start)
}

// 在不需要用户登录场景下 通过该方法来判断是否为中国区域名;
export const isCNDomainByServerless = () => {
  const env = queryEnvForNotProduction();
  const isCNDoamin = isInTargetDomains([
    "online.foxitsoftware.cn",
    "online-stgcn.connectedpdf.com",
    "onlinecn-devazk8s.connectedpdf.com"
  ])
  return env === 'cn' || isCNDoamin
}
export const saveNeedReLoginDrive = (flag = true)=>{
  const v = flag?'1':'0';
  localStorage.setItem('need-re-login-drive',v);
}
export const isNeedReLoginDrive = ()=>{
  return localStorage.getItem('need-re-login-drive')==='1';
}
export const isCanvas = ()=>{
  return getQueryVariable('isCanvas')==='y';
}

export const lmsGetCwsDomain =async ()=>{
    let globalConfig = JSON.parse(localStorage.getItem('phantomOnlineGlobalConfig') || '{}');
    if (!globalConfig.cwsApiUrl) {
        globalConfig = window.phantomOnlineGlobalConfig;
    }
    if (!globalConfig.cwsApiUrl) {
        globalConfig = store.appStore.phantomOnlineGlobalConfig;
    }
    if(globalConfig.cwsApiUrl){
        return globalConfig.cwsApiUrl;
    }
    const url = await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    return url;
}

export function getExtensionByFileName(fileName) {
  const index = fileName.lastIndexOf('.')

  if (index < 0) {
    return null
  }

  return fileName.substring(index)
}

export const saveDriveRefreshCode = (driveType,code)=>{
    const newCodeMap = JSON.parse(localStorage.getItem('Drive_Type_Refresh_Map')||'{}');
    newCodeMap[driveType] = code;
    localStorage.setItem('Drive_Type_Refresh_Map',JSON.stringify(newCodeMap));
  console.log('has window localstorage',localStorage)
  console.log('Drive_Type_Refresh_Map ---->', localStorage.getItem('Drive_Type_Refresh_Map'));
}
export const getDriveRefreshCode = (type)=>{
    const codeMap = JSON.parse(window.localStorage.getItem('Drive_Type_Refresh_Map')||'{}');
    return codeMap[type]||null;
}

export const getFileNameAndType = (fileName)=>{
  if (!fileName) return { name: '', type: '' };
  const index = fileName.lastIndexOf('.');
  const name = fileName.substring(0, index);
  const type = fileName.substring(index + 1);
  return {
    name,
    type,
  };
}

export const mimeMap = {
  "aac": "audio/aac",
  "abw": "application/x-abiword",
  "arc": "application/x-freearc",
  "avi": "video/x-msvideo",
  "azw": "application/vnd.amazon.ebook",
  "bin": "application/octet-stream",
  "bmp": "image/bmp",
  "bz": "application/x-bzip",
  "bz2": "application/x-bzip2",
  "csh": "application/x-csh",
  "css": "text/css",
  "csv": "text/csv",
  "doc": "application/msword",
  "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "eot": "application/vnd.ms-fontobject",
  "epub": "application/epub+zip",
  "gz": "application/gzip",
  "gif": "image/gif",
  "html": "text/html",
  "ico": "image/vnd.microsoft.icon",
  "ics": "text/calendar",
  "jar": "application/java-archive",
  "jpg": "image/jpeg",
  "jpeg": "image/jpeg",
  "js": "text/javascript",
  "json": "application/json",
  "jsonld": "application/ld+json",
  "mid": "audio/midi",
  "midi": "audio/x-midi",
  "mjs": "text/javascript",
  "mp3": "audio/mpeg",
  "cda": "application/x-cdf",
  "mp4": "video/mp4",
  "mpeg": "video/mpeg",
  "mpkg": "application/vnd.apple.installer+xml",
  "odp": "application/vnd.oasis.opendocument.presentation",
  "ods": "application/vnd.oasis.opendocument.spreadsheet",
  "odt": "application/vnd.oasis.opendocument.text",
  "oga": "audio/ogg",
  "ogv": "video/ogg",
  "ogx": "application/ogg",
  "opus": "audio/opus",
  "otf": "font/otf",
  "png": "image/png",
  "pdf": "application/pdf",
  "fdf": "application/vnd.fdf",
  "xfdf": "application/vnd.adobe.fdf",
  "php": "application/x-httpd-php",
  "ppt": "application/vnd.ms-powerpoint",
  "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "rar": "application/vnd.rar",
  "rtf": "application/rtf",
  "sh": "application/x-sh",
  "svg": "image/svg+xml",
  "swf": "application/x-shockwave-flash",
  "tar": "application/x-tar",
  "tif": "image/tiff",
  ".tiff": "image/tiff",
  "ts": "video/mp2t",
  "ttf": "font/ttf",
  "txt": "text/plain",
  "vsd": "application/vnd.visio",
  "wav": "audio/wav",
  "weba": "audio/webm",
  "webm": "video/webm",
  "webp": "image/webp",
  "woff": "font/woff",
  "woff2": "font/woff2",
  "xhtml": "application/xhtml+xml",
  "xls": "application/vnd.ms-excel",
  "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "xml": "application/xml",
  "xul": "application/vnd.mozilla.xul+xml",
  "zip": "application/zip",
  "3gp": "video/3gpp",
  "3g2": "video/3gpp2",
  "7z": "application/x-7z-compressed"
}

export const getCurrencySymbol = (c, s) => {
  let res = '';
  switch (c) {
    case 'CVE':
    case 'BAM':
    case 'LKR':
      res = s;
      if(s.includes('or')){
        res = s.split('or')[1].trim();
      }
      break;
    case 'CNY':
    case 'EGP':
    case 'RSD':
      res = s;
      if(s.includes('or')){
        res = s.split('or')[0].trim();
      }
      break;
    default:
      res = s;
      break;
  }
  return res;
};

export function getEnterpriseIdFromStorage(token) {
  let enterpriseId
  let roleInfo = storageGetItem(localStorage, 'role');
  const sessionToken = storageGetItem(sessionStorage, 'driver_access_token_for_auto_login')
  const { signUpPopupSrcType } = store.userStore

  if(roleInfo){
    roleInfo = JSON.parse(roleInfo);

    if (!token) {
      token = Object.keys(roleInfo)[0]
    }

    enterpriseId = roleInfo[token] && roleInfo[token].enterpriseId
  } else if(sessionToken || signUpPopupSrcType === 'autoLogin') {
    enterpriseId = 'none'
  } else {
    enterpriseId = null
  }

  return enterpriseId
}

export function handleMultiLangForDynamicDict(multiLangDict) {
  const { lng } = store.appStore

  if (lng && lng.lang) {
    return multiLangDict[lng.lang]
  }
}

export function isFromSharePointFn() {
  const oneDriveState = getQueryVariable('oneDriveState');
  const accessTokenId = getQueryVariable('SharePointTokenId');
  const refreshTokenId = getQueryVariable('refreshTokenId');

  if (!oneDriveState || oneDriveState === 'undefined' || !accessTokenId || accessTokenId === 'undefined' || !refreshTokenId || refreshTokenId === 'undefined') {
    return false
  }

  return true
}
export function isFromOfficeAddIn() {
  const from = getQueryVariable('from')

  if (from === 'officeAddIn') {
    return true
  }

  return false
}
export function isFromFoxitWebsite() {
  const from = getQueryVariable('from');

  if (from === 'foxitwebsite') {
    return true
  }

  return false
}

export function saveClientRequestStatusToCache(result, request_csrf, enterpriseId, storageKeyPrefix) {
  let { userInfo: { cUserID }, clientRequestMd5Key } = store.userStore;
  let { ret, data: { reActivationPeriod = 1, sign = '', subscribe_status, subscribe_type, envelop_status } = {} } = result;
  let foxitSignAuthStatusData = '';
  if (storageKeyPrefix === 'FoxitSignAuthStatus') {
    foxitSignAuthStatusData = `-${subscribe_status}${subscribe_type}${envelop_status}`;
  }
  let _localSignString = `${cUserID}-${clientRequestMd5Key}-${enterpriseId}-${reActivationPeriod}${foxitSignAuthStatusData}-${request_csrf}`;
  let _localSign = md5(_localSignString).toString();
  if (_localSign === sign) {
    let data = JSON.stringify({
      ret,
      data: { reActivationPeriod, sign, ...(storageKeyPrefix === 'FoxitSignAuthStatus' ? { subscribe_status, subscribe_type, envelop_status } : {}) },
      request_csrf
    })
    encryptAES(data, store.userStore.getEncryptKey(), '').then(aesEncryptData => {
      let storageKey = `${storageKeyPrefix}-${cUserID}-${enterpriseId}`
      storageSetItem(localStorage, storageKey, aesEncryptData);
    })
  }
}

// 需要报税的国家，账单地址是需要省份/州的
export const taxCountryProvence = (countryCode, isEu = false) => {
  const list = ['US', 'CA'];
  if (list.includes(countryCode) || isEu) {
    return true;
  }
  return false;
};

export const getGaClientId = () => {
  return new Promise((resolve) => {
    if (!window.gtag || !window.TAG_ID) {
      resolve('');
    }
    try {
      window.gtag('get', window.TAG_ID, 'client_id', (client_id) => {
        resolve(client_id);
      });
    } catch (e) {
      resolve('');
    }
  });
};

export async function getClientRequestStatusFromCache(enterpriseId, storageKeyPrefix) {
  let result;
  let { userInfo: { cUserID } = {} } = store.userStore;
  let storageKey = `${storageKeyPrefix}-${cUserID}-${enterpriseId}`;
  let enterpriseInfoCache = storageGetItem(localStorage, storageKey);
  if (enterpriseInfoCache) {
    try {
      let aesDecryptData = await decryptAES(enterpriseInfoCache, store.userStore.getEncryptKey(), '')
      let cacheData = JSON.parse(aesDecryptData);
      let { data: { reActivationPeriod = 1 }, request_csrf } = cacheData;
      let _reActivationPeriod = !isNaN(Number(reActivationPeriod)) ? Number(reActivationPeriod) : 1; // 离线使用过期，小时为单位，默认1小时
      if (new Date().getTime() <= (request_csrf + _reActivationPeriod * 60 * 60 * 1000)) {
        // 在过期时间内
        result = cacheData;
      }
    } catch (error) {
      result = undefined;
    }
  }
  return result;
}
export function isAISupported(){
    const isTestEnv = ['online-azk8s.foxitcloud.com/','localhost:3000/'].some(url=>location.href.indexOf(url)!==-1)
    return isTestEnv||isCADomain()||isPdfOnlineDomain()
}

export const NoAICountry=[
    'Hong Kong',
    'China',
    'Albania',
    'Andorra',
    'Armenia',
    'Austria',
    'Azerbaijan',
    'Belarus',
    'Belgium',
    'Bosnia and Herzegovina',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czechia',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Georgia',
    'Germany',
    'Gibraltar',
    'Greece',
    'Hungary',
    'Iceland',
    'Ireland',
    'Isle of Man',
    'Italy',
    'Kazakhstan',
    'Latvia',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'North Macedonia',
    'Macedonia',
    'Malta',
    'Moldova',
    'Monaco',
    'Montenegro',
    'Netherlands',
    'Norway',
    'Poland',
    'Portugal',
    'Romania',
    'Russia',
    'San Marino',
    'Serbia',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
    'Switzerland',
    'Turkey',
    'Ukraine',
    'United Kingdom',
    'Vatican City ',
]

export function trimStr(operateStr) {
  if (typeof operateStr === 'string') {
    return operateStr.trim()
  }
}

/**
 * @description 从 Storage 获取 当前 用户的数据
 * @param {string} cUserID 当前用户id, 如果是企业用户需要拼接上 '_${enterpriseId}'
 * @param {Storage} storage 本地存储库
 * @param {string} key 存储键
 * 
*/
export function getLocalStorageUserMapValue(cUserID, storage, key) {
  let currentValue = undefined;
  let storageValue = storageGetItem(storage, key);
  if (storageValue) {
    try {
      let currentUserValueMap = JSON.parse(storageValue);
      if (currentUserValueMap && typeof currentUserValueMap === 'object' && currentUserValueMap[cUserID]) {
        currentValue = currentUserValueMap[cUserID];
      }
    } catch (error) {
    }
  }
  return currentValue;
}
/**
 * @description 往 Storage 存储 当前 用户的数据
 * @param {string} cUserID 当前用户id, 如果是企业用户需要拼接上 '_${enterpriseId}'
 * @param {Storage} storage 本地存储库
 * @param {string} key 存储键
 * @param value 存储值
 * @param {boolean} [isRemove] 是否移除当前用户的数据
 * 
*/
export function setLocalStorageUserMapValue(cUserID, storage, key, value, isRemove = false) {
  try {
    let storageValue = storageGetItem(storage, key);
    let currentUserValueMap = {};
    if (storageValue && typeof JSON.parse(storageValue) === 'object') {
      currentUserValueMap = { ...JSON.parse(storageValue) };
    }
    if (isRemove) {
      if (cUserID in currentUserValueMap) {
        delete currentUserValueMap[cUserID];
      }
    } else {
      currentUserValueMap[cUserID] = value;
    }
    storageSetItem(storage, key, JSON.stringify(currentUserValueMap));
  } catch (error) {
  }
}

/**
 * Retry an API function a specified number of times with a delay between retries.
 * @param {Function} func - The API function to retry.
 * @param {number} [retryCount=3] - The number of times to retry the API function.
 * @param {number} [retryDelay=1000] - The delay in milliseconds between retries.
 * @returns {Promise<any>} - A promise that resolves when the API function succeeds or rejects if all retries fail.
 */
export function apiRetryFunc(func, retryCount = 3, retryDelay = 1000) {
  return new Promise((resolve, reject) => {
    let retry = 0;
    let retryFunc = () => {
      func().then(resolve).catch(error => {
        retry++;
        if (retry < retryCount) {
          setTimeout(retryFunc, retryDelay);
        } else {
          reject(error);
        }
      })
    }

    retryFunc();
  })
}
